import { BaseCell } from '_core/react-window/cells';
import { ListTable, ListTableColumn } from '_core/react-window/listTable';
import { Toolbar } from '_core/toolbar';
import { Button } from '@blueprintjs/core';
import { Row, VGrid } from 'layout/contentLayout';
import { PartnersAutocompleteInFormGroupForFinalForm } from 'partners/autocomplete';
import * as React from 'react';
import { useCallback, useMemo, useState } from 'react';
import { useFieldArray } from 'react-final-form-arrays';

export interface IOwnersFieldItem {
  owner: number | null;
}

interface ITableItem extends IOwnersFieldItem {
  index: number;
}

interface IProps {
  name: string;
  readOnly: boolean;
}

export function OwnersField({ name, readOnly }: IProps) {
  const { fields, meta } = useFieldArray(name);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const columns = useMemo(
    (): Array<ListTableColumn<ITableItem>> => [
      {
        id: 'owner',
        label: 'Собственник',
        defaultWidth: 350,
        renderCell: ({ children, style }) => (
          <BaseCell noPadding style={style}>
            {children}
          </BaseCell>
        ),
        renderCellContent: (_rowItem, rowIndex) => (
          <PartnersAutocompleteInFormGroupForFinalForm
            addToQuery={{ isSupplier: true }}
            id={`${fields.name}[${rowIndex}].owner`}
            name={`${fields.name}[${rowIndex}].owner`}
            noBottomMargin
            readOnly={readOnly}
          />
        ),
      },
    ],
    [fields.name, readOnly]
  );

  const getItemId = useCallback((item: ITableItem) => String(item.index), []);

  const items = useMemo(
    () => fields.value.map((item, index): ITableItem => ({ ...item, index })),
    [fields.value]
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isDisabled = (meta as any).submitting as boolean;

  return (
    <VGrid>
      <Row>
        <Toolbar>
          <Button
            disabled={isDisabled || readOnly}
            text="Добавить"
            onClick={() => {
              fields.push({ owner: null });
            }}
          />

          <Button
            disabled={isDisabled || readOnly || selectedItems.length === 0}
            text="Удалить выбранные"
            onClick={() => {
              selectedItems
                .map(Number)
                .sort((a, b) => b - a)
                .forEach(rowIndex => {
                  fields.remove(rowIndex);
                });

              setSelectedItems([]);
            }}
          />
        </Toolbar>
      </Row>

      <Row>
        <ListTable
          columns={columns}
          getItemId={getItemId}
          items={items}
          maxHeight={200}
          selectedItems={selectedItems}
          selectionIsDisabled={isDisabled || readOnly}
          onSelectedItemsChange={setSelectedItems}
        />
      </Row>
    </VGrid>
  );
}
